import { CSSObjectWithLabel, StylesConfig } from 'react-select';
import { TINY_VIEWPORT_WIDTH, SMALL_VIEWPORT_WIDTH } from './constants';

export const MediaSelectStyles: StylesConfig = {
  control: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      color: 'black',
      backgroundColor: 'white',
      height: '30px',
      width: '370px',
      zIndex: zIndex,
    }
  },
  singleValue: (provided) => ({
    ...provided,
    color: 'white',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#595959',
  }),
  menu: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      boxSizing: 'border-box',
      backgroundColor: 'white',
      borderRadius: '3px 3px 16px 16px',
      paddingTop: '5px',
      marginLeft: '1px',
      width: '368px',
      opacity: 100,
      zIndex: zIndex,
      boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.5)',
      border: '2px solid #cccccc',
    }
  },
  noOptionsMessage: (provided) => ({
    ...provided,
    fontSize:'14px',
    color:'black',
    textAlign:'left'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#595959"
  }),
  input: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      color: "black",
      zIndex: zIndex,
    }
  },
  menuList: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      boxSizing: 'border-box',
      backgroundColor: 'white',
      borderRadius: "0px 0px 16px 16px",
      margin: '3px 3px 4px 3px',
      padding: '0 6px 3px 3px',
      width: '360px',
      opacity: 100,
      zIndex: zIndex,
    };
  }, 
};

export const SourcesSelectStyles: StylesConfig = {
  control: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      color: 'black',
      backgroundColor: 'white',
      height: '30px',
      width: '370px',
      zIndex: zIndex,
    }
  },
  singleValue: (provided) => ({
    ...provided,
    color: 'white',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#595959',
  }),
  menu: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      boxSizing: 'border-box',
      backgroundColor: 'white',
      borderRadius: '3px 3px 16px 16px',
      paddingTop: '5px',
      marginLeft: '1px',
      width: '368px',
      opacity: 100,
      zIndex: zIndex,
      boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.5)',
      border: '2px solid #cccccc',
    }
  },
  noOptionsMessage: (provided) => ({
    ...provided,
    fontSize:'14px',
    color:'black',
    textAlign:'left'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#595959"
  }),
  input: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      color: "black",
      zIndex: zIndex,
    }
  },
  menuList: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      boxSizing: 'border-box',
      backgroundColor: 'white',
      borderRadius: "0px 0px 16px 16px",
      margin: '3px 3px 4px 3px',
      padding: '0 6px 3px 3px',
      width: '360px',
      opacity: 100,
      zIndex: zIndex,
    };
  }, 
};

export const TzSelectStyles: StylesConfig = {
  control: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      color: 'black',
      backgroundColor: 'white',
      height: '40px',
      width: '200px',
      borderRadius: '8px',
      zIndex: zIndex,
    }
  },
  singleValue: (provided) => ({
    ...provided,
    color: '#595959',
    fontSize: '14px',
    fontFamily: 'Inter',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#595959',
  }),
  menu: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      boxSizing: 'border-box',
      backgroundColor: 'white',
      borderRadius: '3px 3px 16px 16px',
      paddingTop: '5px',
      marginLeft: '1px',
      width: '260px',
      opacity: 100,
      zIndex: zIndex,
      boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.5)',
      border: '2px solid #cccccc',
    }
  },
  noOptionsMessage: (provided) => ({
    ...provided,
    fontSize:'14px',
    color:'black',
    textAlign:'left'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#595959",
  }),
  input: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      color: "black",
      zIndex: zIndex,
    }
  },
  menuList: (provided, state) => {
    let zIndex = 0;
    if (state.selectProps?.className) {
      const zIndexStr = state.selectProps?.className.split('-')[1];
      if (zIndexStr) {
        zIndex = parseInt(zIndexStr);
      }
    }
    return {
      ...provided,
      boxSizing: 'border-box',
      backgroundColor: 'white',
      borderRadius: "0px 0px 16px 16px",
      margin: '3px 3px 4px 3px',
      padding: '0 6px 3px 3px',
      width: '254px',
      opacity: 100,
      zIndex: zIndex,
    };
  },
};

/** Full-width variant for admin selects (user/case names, emails). Uses 100% width so w-full works. */
export const TzSelectStylesFullWidth: StylesConfig = {
  ...TzSelectStyles,
  control: (provided, state) => {
    const base = TzSelectStyles.control?.(provided, state) ?? provided;
    return { ...base, width: '100%', minWidth: 0 };
  },
  menu: (provided, state) => {
    const base = TzSelectStyles.menu?.(provided, state) ?? provided;
    return { ...base, width: '100%', minWidth: 0 };
  },
  menuList: (provided, state) => {
    const base = TzSelectStyles.menuList?.(provided, state) ?? provided;
    return { ...base, width: '100%', minWidth: 0 };
  },
};

export const SelectStyles: StylesConfig = {
  control: (provided, state) => {
    const isSmallViewport = window.innerWidth < SMALL_VIEWPORT_WIDTH;
    const isTinyViewport = window.innerWidth < TINY_VIEWPORT_WIDTH;
    let maxWidth = isSmallViewport ? (isTinyViewport ? '258px' : '258px') : '258px';
    let minWidth = isSmallViewport ? (isTinyViewport ? '258px' : '258px') : '258px';
    const preOverride = {
      ...provided,
      position: 'relative',
      width: '258px',
      zIndex: '20',
      boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '0px 2.5px 0px 10px',
      gap: isTinyViewport ? '0' : '5px',
      backgroundColor: '#378BF0',
      color: 'white',
      fontSize: '14px',
      border: state.isFocused ? '1px solid rgba(255, 255, 255, 0.5)' : '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '9999px',
      cursor: 'pointer',
      '&:hover': {
        border: '1px solid rgba(255, 255, 255, 0.5)',
      },
    };
    if (state.selectProps?.className?.includes(' min-w-')) {
      // don't change the min-width we already set
    } else {
      preOverride.maxWidth = maxWidth;
    }
    if (state.selectProps?.className?.includes(' max-w-')) {
      // don't change the max-width we already set
    } else {
      preOverride.maxWidth = maxWidth;
    }
    return {
      ...preOverride,
    } as CSSObjectWithLabel;
  },
  option: (provided) => ({
    ...provided,
    color: 'black',
    fontSize:'14px',
    overflow: 'hidden',
    borderRadius: '16px',
    border: '1px solid #f4f4f4',
    margin: '4px 0px',
    cursor: 'pointer',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'white',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: 'white',
  }),
  menu: (provided) => {
    return {
      ...provided,
      boxSizing: 'border-box',
      backgroundColor: '#fff',
      borderRadius: '0px 0px 16px 16px',
      marginTop: '-20px',
      paddingTop: '20px',
      marginLeft: '0px',
      width: '258px',
      boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.1)',
    };
  },
  noOptionsMessage: (provided) => ({
    ...provided,
    fontSize:'14px',
    color:'black',
    textAlign:'left'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#FFFFFF"
  }),
  input: (provided) => ({
    ...provided,
    color: "#FFFFFF",
  }),
  menuList: (provided) => {
    return {
      ...provided,
      boxSizing: 'border-box',
      borderRadius: "0px 0px 16px 16px",
      margin: '3px 3px 3px 5px',
      padding: '0 6px 0 3px',
    };
  },    
};